export default __webpack_public_path__ + "static/media/alma.4092780a.jpg";